// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the MIT License.

export const version = '4.12.0';

export const returnBindingKey = '$return';
